<template>
  <div class="riddle__top">
    <span class="riddle__label">{{ `${$t('riddle')} ${riddle.order}` }}</span>
    <Location :link="riddle.address.link" :label="riddle.address.name" />
  </div>
  <h1 class="title">{{ riddle.question }}</h1>
  <Chat
    :messages="riddle.context"
    riddle
    @rendered="$emit('rendered')"
    :render-cache-key="`riddle-content-${riddle.id}`"
  />
</template>

<script>
import { Chat } from '@/components/blocks'
import { Location } from '@/components/small'

export default {
  name: 'RiddleContent',
  components: { Chat, Location },
  props: {
    riddle: {
      type: Object,
      required: true,
    },
  },
  emits: ['rendered'],
}
</script>
